/**
 * Created by casteloyee on 2017/7/28.
 */
import React from 'react';
import {Modal, Row, Col, Input, Radio, Select, message, Tabs, Form} from 'antd';
import API_URL from '../../common/url';
import StringUtil from '../../common/StringUtil';
import AjaxRequest from '../../common/AjaxRequest';
import SiteSearchInput from "./SiteSearchInput";
import CustomerSearchInput from "./CustomerSearchInput";

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;

class AddCRAForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            confirmLoading: false,
            investigationSiteId: '',
            investigationSiteCode: '',
            investigationSiteIdCustom: '',
            investigationSiteCodeCustom: '',
            user: {},
            selectedTab: "searchAdd",
        };
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({
                investigationSiteId: '',
                investigationSiteCode: '',
                investigationSiteIdCustom: '',
                investigationSiteCodeCustom: '',
                user: {}
            });
        }
    }

    hide = () => {
        this.props.form.resetFields();
        this.props.changeCraVisible(false);
    };

    handleSelectSite = value => {
        this.setState({
            investigationSiteId: value.value,
            investigationSiteCode: value.text,
        });
    };

    handleSelectSiteCustom = value => {
        this.props.form.setFieldsValue({
            investigationSiteIdCustom: value.value,
        })
        this.setState({
            investigationSiteIdCustom: value.value,
            investigationSiteCodeCustom: value.text,
        });
    };

    handleSelectUser = value => {
        this.setState({
            user: value,
        });
    };

    handleSubmit = () => {
        if(this.state.selectedTab == "searchAdd"){
            const { user, investigationSiteId } = this.state;
            const invSiteId = investigationSiteId || sessionStorage.siteId;
            if((!invSiteId || invSiteId == "0")){
                message.error("请选择中心");
                return;
            }
            if(!user.value){
                message.error("请选择CRA");
                return;
            }
            this.setState({
                confirmLoading:true,
            })
            const options = {
                url: `${API_URL.user.addCRA}`,
                data: {
                    userId: user.value,
                    invSiteId,
                },
                dataType: 'json',
                doneResult: ( data => {
                    this.setState({
                        confirmLoading:false,
                    })
                    this.hide();
                    message.success("添加成功");
                    this.props.reload();
                }),
                errorResult: data => {
                    this.setState({
                        confirmLoading:false,
                    })
                }
            };
            AjaxRequest.sendRequest(options);
        }else if(this.state.selectedTab == "customAdd"){
            this.props.form.validateFields((err, values) => {
                if (err) {
                  return;
                }
                const fieldValue = this.props.form.getFieldsValue() || {};
                const {userCompellation, userEmail, userMobile, userTelphone} = fieldValue;
                const { investigationSiteIdCustom } = this.state;
                const invSiteId = investigationSiteIdCustom || sessionStorage.siteId;
                if(!invSiteId){
                    message.error("请选择中心");
                    return;
                }
                this.setState({
                    confirmLoading:true,
                })
                const options = {
                    url: `${API_URL.user.addCRACustom}`,
                    data: {
                        invSiteId,
                        userCompellation,
                        userEmail,
                        userMobile,
                        userTelphone
                    },
                    dataType: 'json',
                    doneResult: ( data => {
                        this.setState({
                            confirmLoading:false,
                        })
                        this.hide();
                        message.success("添加成功");
                        this.props.reload();
                    }),
                    errorResult: data => {
                        this.setState({
                            confirmLoading:false,
                        })
                    }
                };
                AjaxRequest.sendRequest(options);
            });
        }
    };
    
    changeTab = (key) => {
        this.setState({
            selectedTab: key
        })
    }

    watchValueClear = (key) => {
        this.props.form.setFieldsValue({
            [key]:""
        })
        this.setState({
            [key]:""
        })
    }

    render() {
        const { form, visible } = this.props;
        const { confirmLoading, user } = this.state;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
              span: 10
            },
            wrapperCol: {
              span: 13
            },
          };
        return (
            <Modal
                title="添加CRA"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal addCraModal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div>
                <Tabs onTabClick={this.changeTab} type="card">
                    <TabPane tab="检索添加" key="searchAdd">
                        <div>
                            <Row>
                                <Col span={9} style={{textAlign: "right",paddingRight:"13px"}}>
                                    {(sessionStorage.siteId > 0) ?
                                    <span>中心名称(中心编号)：</span>
                                    :
                                    <span><span className="red_sim">*</span>中心名称(中心编号)：</span>
                                    }
                                </Col>
                                <Col span={1}/>
                                <Col span={13} style={{whiteSpace:"normal",wordBreak:"break-all"}}>
                                     {
                                        (sessionStorage.siteId > 0) ?
                                        <span>{`${sessionStorage.investigationSiteName}(${sessionStorage.investigationSiteCode})`}</span>
                                        :
                                            (
                                                visible &&
                                                <SiteSearchInput placeholder="输入中心编号\中心名称" style={{width: 200}}
                                                            handleSelectSite = {this.handleSelectSite}
                                                />
                                            )
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col span={9} style={{textAlign: "right",paddingRight:"13px"}}><span className="red_sim">*</span>选择CRA：</Col>
                                <Col span={1}/>
                                <Col>
                                    {
                                        visible &&
                                        <CustomerSearchInput placeholder="输入姓名\手机号码" style={{width: 200}}
                                                handleSelectUser = {this.handleSelectUser}
                                                url = {`${API_URL.customer.list}`}
                                                searchKey='keyword'
                                        />
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col span={9} style={{textAlign: "right",paddingRight:"13px"}}>手机号码：</Col>
                                <Col span={1}/>
                                <Col>{ user.userMobile }</Col>
                            </Row>
                            <Row>
                                <Col span={9} style={{textAlign: "right",paddingRight:"13px"}}>固定电话：</Col>
                                <Col span={1}/>
                                <Col>{ user.userTelphone }</Col>
                            </Row>
                            <Row>
                                <Col span={9} style={{textAlign: "right",paddingRight:"13px"}}>邮箱：</Col>
                                <Col span={1}/>
                                <Col>{ user.userEmail }</Col>
                            </Row>
                        </div>
                    </TabPane>
                    <TabPane tab="自定义添加" key="customAdd">
                    <div>
                            <Form>
                                {
                                (sessionStorage.siteId > 0) ?
                                <Row>
                                    <Col span={10} style={{textAlign: "right",paddingRight:"13px"}}>
                                            <span>中心名称(中心编号)：</span>
                                    </Col>
                                    <Col span={13} style={{whiteSpace:"normal",wordBreak:"break-all"}}>
                                            <span>{`${sessionStorage.investigationSiteName}(${sessionStorage.investigationSiteCode})`}</span>
                                    </Col>
                                </Row>
                                :
                                <div className="field-max">
                                <FormItem label="中心名称(中心编号)"  {...formItemLayout}>
                                    
                                        <Col span={13} style={{whiteSpace:"normal",wordBreak:"break-all",float:'none'}}>
                                            {
                                                visible &&
                                                <SiteSearchInput placeholder="输入中心编号\中心名称" style={{width: 200}}
                                                    handleSelectSite = {this.handleSelectSiteCustom}
                                                    watchValueClear = {()=> {this.watchValueClear("investigationSiteIdCustom")}}
                                                />
                                            }
                                        </Col>
                                    {
                                        getFieldDecorator('investigationSiteIdCustom',{
                                            rules:[
                                                {required:true, message:'中心不能为空'}
                                            ]
                                        })(
                                            <Input style={{display:'none'}} />
                                        )
                                    }
                                </FormItem>
                            </div>
                            }    

                                <div className="field-max">
                                    <FormItem label="姓名" {...formItemLayout}>
                                        {
                                            getFieldDecorator('userCompellation', {
                                                rules: [
                                                    { required: true, message: '姓名不能为空' },
                                                    // { max: 8, message: '姓名最多4个字' },
                                                ],
                                            })(<Input placeholder="请在此输入姓名" />)
                                        }
                                    </FormItem>
                                </div>
                                <div className="field-max">
                                    <FormItem label="手机" {...formItemLayout}>
                                        {
                                            getFieldDecorator('userMobile', {
                                                rules: [
                                                    { required: true, message: '号码不能为空' },
                                                    { pattern:/^\d{11}$/, message: '必须是11位的手机号' },
                                                ],
                                            })(<Input placeholder="请在此输入手机号" maxLength="11" />)
                                        }
                                    </FormItem>
                                </div>
                                <div className="field-max">
                                    <FormItem label="固定电话" {...formItemLayout}>
                                        {
                                            getFieldDecorator('userTelphone',{
                                                rules:[
                                                    { pattern:/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '必须是固定电话格式' },                                        
                                                ]
                                            })(<Input placeholder="请在此输入固话" />)
                                        }
                                    </FormItem>
                                </div>
                                <div className="field-max">
                                    <FormItem label="邮箱" {...formItemLayout}>
                                        {
                                            getFieldDecorator('userEmail',{
                                                rules:[
                                                    { pattern:/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: '必须电子邮箱格式' },                                        
                                                ],
                                            }
                                            )(<Input placeholder="请在此输入电子邮箱" />)
                                        }
                                    </FormItem>                        
                                </div>                    
                            </Form>
                        </div>
                    </TabPane>
                </Tabs>
                </div>
                
            </Modal>
        )
    }
}

const AddCRA = Form.create()(AddCRAForm);

export default AddCRA;



// WEBPACK FOOTER //
// ./src/components/site/AddCRA.js